"use client";

import { FeatureHighlight } from "@/components/shared/public";
import { useTranslations } from "next-intl";
import Image from "next/image";
import { threeSixtyLogo } from "../../../../public/images/logos";
import { matterportCam } from "../../../../public/images/three-sixty";

const ServiceDescription = () => {
  const t = useTranslations("threeSixtyService");

  return (
    <div className="gs--page-column py-16">
      <div className="flex w-full flex-col items-center gap-10 md:flex-row">
        <FeatureHighlight
          src={threeSixtyLogo}
          alt={"floor plan design logo"}
          title={t("serviceDescription.title")}
          text={t("serviceDescription.text")}
          subText={t("serviceDescription.text2")}
          subText2={t("serviceDescription.text3")}
        />
        <Image
          className="border p-0.5"
          src={matterportCam}
          alt={"360 Grad Matterport Service Kamera"}
          sizes="(max-width: 768px) 100vw, (max-width: 1024px) 250vw, 300vw"
          loading="lazy"
        />
      </div>
    </div>
  );
};

export default ServiceDescription;
